'use strict';

import { getDistance } from 'geolib';

import { searchAddresses } from '../api/searchAddresses';

import { translateOSMKey } from '../utils/translateOSMKey';

import { SelectSearchResultInput } from '../objects/selectSearchResultInput';

export function DistanceInputs(params) {
    const context = params.context;
    const tripDepartureStationInputElement = params.tripDepartureStationInputElement;
    const tripArrivalStationInputElement = params.tripArrivalStationInputElement;
    const onChange = (!!params && params.onChange && typeof params.onChange === 'function') ? params.onChange : null;

    let tripDepartureStations = [];
    let tripDepartureStationCoordinates = null;
    let tripArrivalStations = [];
    let tripArrivalStationCoordinates = null;

    function formatStationOptionLabel(properties) {
        let label = '';

        if (properties.street) {
            label += properties.street
        }

        if (properties.city) {
            if (label.length > 0) label += ', '
            label += properties.city
        }

        if (properties.country) {
            if (label.length > 0) label += ', '
            label += properties.country
        }

        const osmKey = translateOSMKey(properties.osm_key, 'fr');

        if (osmKey) label += ' (' + osmKey + ')';

        return label;
    }

    function calculateDistance(departureCoordinates, arrivalCoordinates) {
        if (departureCoordinates && arrivalCoordinates) {
            let distance = getDistance(
                {
                    latitude: departureCoordinates[0],
                    longitude: departureCoordinates[1]
                },
                {
                    latitude: arrivalCoordinates[0],
                    longitude: arrivalCoordinates[1]
                }
            );

            return distance / 1000;
        } else {
            return 0;
        }
    }

    const tripDepartureStationInput = new SelectSearchResultInput({
        element: tripDepartureStationInputElement,
        getOptions: function (search, callback, errorCallback) {
            searchAddresses(
                search,
                context,
                function (response) {
                    tripDepartureStations = response.features;

                    const options = tripDepartureStations.map(object => {
                        const option = {
                            value: object.properties.id,
                            label: object.properties.name + ', ' + formatStationOptionLabel(object.properties)
                        };
                        return option;
                    });

                    callback(options);
                },
                function () {
                    errorCallback();
                }
            );
        },
        onInput: function (value) {
            const filteredStations = (tripDepartureStations.length) ? tripDepartureStations.filter(object => { return object.properties.id === value }) : [];
            tripDepartureStationCoordinates = filteredStations.length ? filteredStations[0].geometry.coordinates : null;

            const distance = calculateDistance(tripDepartureStationCoordinates, tripArrivalStationCoordinates);
            if (onChange) onChange(distance);
        },
        onChange: function (value) {
            const filteredStations = tripDepartureStations.filter(object => { return object.properties.id === value });
            
            if (filteredStations.length) {
                tripDepartureStationInputElement.value = filteredStations[0].properties.name;
                tripDepartureStationCoordinates = filteredStations[0].geometry.coordinates;
                const distance = calculateDistance(tripDepartureStationCoordinates, tripArrivalStationCoordinates);
                if (onChange) onChange(distance);
            }
        }
    });

    const tripArrivalStationInput = new SelectSearchResultInput({
        element: tripArrivalStationInputElement,
        getOptions: function (search, callback, errorCallback) {
            searchAddresses(
                search,
                context,
                function (response) {
                    tripArrivalStations = response.features;

                    const options = tripArrivalStations.map(object => {
                        const option = {
                            value: object.properties.id,
                            label: object.properties.name + ', ' + formatStationOptionLabel(object.properties)
                        };
                        return option;
                    });

                    callback(options);
                },
                function () {
                    errorCallback();
                }
            );
        },
        onInput: function (value) {
            const filteredStations = tripArrivalStations.length ? tripArrivalStations.filter(object => { return object.properties.id === value }) : [];
            tripArrivalStationCoordinates = filteredStations.length ? filteredStations[0].geometry.coordinates : null;

            const distance = calculateDistance(tripDepartureStationCoordinates, tripArrivalStationCoordinates);
            if (onChange) onChange(distance);
        },
        onChange: function (value) {
            const filteredStations = tripArrivalStations.filter(object => { return object.properties.id === value });

            if (filteredStations.length) {
                tripArrivalStationInputElement.value = filteredStations[0].properties.name;
                tripArrivalStationCoordinates = filteredStations[0].geometry.coordinates;
                const distance = calculateDistance(tripDepartureStationCoordinates, tripArrivalStationCoordinates);
                if (onChange) onChange(distance);
            }
        }
    });
}
